<mat-dialog-content>
  <div class="absolute top-0 right-0">
    <app-close-button
      (closeCalled)="dialogRef.close()"
      data-cy="directions-overlay.close-button"
    >
    </app-close-button>
  </div>

  <div class="pt-4">
    <platform-directions-selector
      data-cy="directions-overlay.directions-selector"
      [origin]="data.origin"
      [destination]="data.destination"
      [services]="config | async"
      [translations]="{
        heading: 'map_directions_selector_heading' | translate
      }"
    >
    </platform-directions-selector>
  </div>
</mat-dialog-content>
